/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:9179c832-eaa7-43bc-a29c-3ad55049fb41",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_7oZ81TP25",
    "aws_user_pools_web_client_id": "4nmijmddur4sckj0pdfc9ph879",
    "oauth": {},
    "aws_content_delivery_bucket": "slippy-20200828161730-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "ap-southeast-2",
    "aws_content_delivery_url": "https://d27hseomlegu2f.cloudfront.net",
    "state_queue_url": "https://sqs.ap-southeast-2.amazonaws.com/675679404987/slippy-prod-StateQueue-1T9L2VWLM2XP"
};


export default awsmobile;
